export interface ISaveResult {
  assignedId: number;
  statusCode: number;
  messages: string[];
  success: boolean;
}
